import * as React from 'react';
import {
    ButtonGroup,
    InputGroup,
    FormControl,
    ToggleButton, Row, Col,
} from 'react-bootstrap';
import FormContainer from './FormContainer';
import useTranslation from "../hooks/useTranslation";

const BetterSearchBar = ({
                       searchQuery,
                       setSearchQuery,
                       radioValue,
                       setRadioValue,
                        language, t
                   }) => {
    const radios = [
        { name: t('in_names'), value: 'search' },
        { name: t('in_tags'), value: 'tagSearch' },
    ];



    return (
        <FormContainer autoComplete='off'>
                    <Row className={'mb-4 text-md-left text-center align-items-center'}>
                        <Col className={'pr-md-0 pr-xl-0 pr-lg-0'} sm={12} md={6}>
                            <FormControl
                                value={searchQuery}
                                onInput={(e) => setSearchQuery(e.target.value)}
                                type='text'
                                id='header-search'
                                placeholder={t('search')}
                                variant='outline-secondary'
                            />
                        </Col>
                        <Col className={'pl-md-0 pl-xl-0 pl-lg-0'} sm={12} md={6}>
                            <ButtonGroup toggle>
                                {radios.map((radio, idx) => (
                                    <ToggleButton
                                        key={idx}
                                        type='radio'
                                        variant='info'
                                        name='radio'
                                        value={radio.value}
                                        checked={radioValue === radio.value}
                                        style={{
                                            backgroundColor: radioValue === radio.value ? '#4bbf73' : '#b8b6b6'
                                        }}
                                        onChange={(e) =>
                                            setRadioValue(e.currentTarget.value)
                                        }
                                    >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                        </Col>
                    </Row>

        </FormContainer>
    );
};

export default BetterSearchBar;
